import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "edit-form" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "permissions" }
const _hoisted_9 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_Suitcase = _resolveComponent("Suitcase")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_Finished = _resolveComponent("Finished")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_collapse = _resolveComponent("el-collapse")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.ROLE,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['ROLE_SELECT'] && !_ctx.loading]
        ]),
        (_ctx.hasPermission['ROLE_SELECT'])
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Rollen', '/role'], [_ctx.roleName]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['ROLE_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.activeName) = $event)),
                      accordion: "",
                      ref: "coll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, { name: "1" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Suitcase)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title-label" }, "Stammdaten", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_form, {
                                  ref: "editRoleForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.roleModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Name",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.roleModel.name,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.roleModel.name) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Beschreibung",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.roleModel.description,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.roleModel.description) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formRoleValid,
                                          onClick: _ctx.onRoleSaveClick
                                        }, {
                                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode(" Speichern ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "2" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Finished)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title-label" }, "Berechtigungen", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionModelList, (permission, index) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: permission.permissionid
                                  }, [
                                    (index == 0 || _ctx.permissionModelList[index -1].code.substring(0,4) != permission.code.substring(0,4) )
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.sections[permission.code.substring(0,4)]), 1))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.permissions[permission.permissionid],
                                      "onUpdate:modelValue": $event => ((_ctx.permissions[permission.permissionid]) = $event),
                                      "active-text": permission.name,
                                      "inactive-text": "",
                                      onChange: $event => (_ctx.onPermissionChange(permission))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "active-text", "onChange"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}